<template>
  <div class="private" >
    <div class="box">
        <p class="list_item bot">《掌上盈服务协议》（以下简称“本协议”）是由五矿证券有限公司（以下简称“我司”）就掌上盈平台（以下简称“本平台”）相关服务事项和您签订。</p>
        <h5>1、协议确认</h5>
        <p class="list_item bot">本协议亦适用于任何有关本平台的后期发行和升级。本协议通过电子方式签署，您在登录平台过程中点击同意协议，即表示您已详细阅读并充分理解本协议的条款，同意遵守与我司已达成的协议并同意本协议的全部内容。此外，我司有权不时对本协议进行修改和更新，修改后的协议将在本平台界面中实时更新公示，以便您能够及时了解。若您选择同意并继续使用本平台及其服务的，即表示您接受修改后的协议，也将遵循变更后的协议使用平台服务。</p>
        <h5>2、知识产权声明</h5>
        <p class="list_item">2.1、本平台及其相关服务仅供用于非商业环境和活动。未经我公司授权，任何用于商业用途的拷贝、销售、转让、出租、修改本平台的行为均被认为是侵权行为。</p>
        <p class="list_item">2.2、保留权利：未明示授权的其他一切权利仍归我司所有，您使用其他权利时须另外取得我司书面同意。</p>
        <p class="list_item bot">2.3、本协议并未对我司其他服务的条款作出规定。对于这些服务，可能有单独的服务条款加以规范，请您在使用有关服务时另行了解与确认。</p>
        <h5>3、使用须知</h5>
            <p class="list_item">3.1、您应保证注册登记本平台时提供的资料真实无误。</p>
            <p class="list_item">3.2、您在遵守法律及本协议的前提下可依据本协议使用本平台。您在使用本平台过程中，不得以任何方式实施，也不得同意、授权或指示任何其他主体从事包括但不限于下列任何行为：</p>
            <p class="list_item text2">（1）删除本平台及其他副本上所有关于著作权的信息和内容；</p>
            <p class="list_item text2">（2）对本平台进行反向工程、反向汇编、反向编译等；</p>
            <p class="list_item text2">（3）对于本平台的图像、文字等相关信息，未经我司书面同意，擅自实施包括但不限于下列行为：复制、修改、链接、转载、汇编、发表、出版、建立镜像站点，擅自借助本平台发展与之有关的衍生平台、作品、服务等。</p>
            <p class="list_item text2">（4）利用本平台发表、传播、储存违反国家法律、危害国家安全、祖国统一、社会稳定的内容，或涉嫌侮辱、诽谤、色情、暴力等任何违反国家法律法规政策的内容。</p>
            <p class="list_item text2">（5）利用本平台发表、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容。</p>
            <p class="list_item">3.3、我司会尽最大努力向您提供服务，确保服务的连贯性和安全性；但我司不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。您应加强信息安全意识，注意加强密码保护以免遭致损失。</p>
            <p class="list_item">3.4、建议您不要购买、下载、安装、使用非经我司开发并正式发布的其它任何由本平台衍生的平台，由于使用前述平台产生的一切法律责任与纠纷一概与我司无关。</p>
            <p class="list_item">3.5、我司保留在任何时候为您提供本平台的修改、升级版本的权利，以及为修改或升级服务收取费用的权利。</p>
            <p class="list_item">3.6、由于本平台中的数据和信息来源涉及到多方提供、处理、传输的环节，本平台力求审慎但不保证数据的准确性、有效性和及时性。本平台中的所有图表、数据、资讯信息以及经过整理分析后的各种统计结果等，包括但不限于财经资讯、金融数据以及其他信息，仅供您参考，并不作为您的投资依据，您因此而遭受的经济损失，我司不承担责任。</p>
            <p class="list_item">3.7、 您使用本平台过程中所产生的数据流量费甶当地运营商收取，与我司无关。</p>
            <p class="list_item">3.8、根据《网络安全法》等法律法规要求，您在使用本平台时，我司将收集您的信息，具体使用规则与您达成如下一致意见：</p>
            <p class="list_item text2">（1）我司出于包括但不限于以下所列目的收集您的信息：法律法规规定、国家有权机关调查或检查要求、用于外部监管报送、客户身份识别、客户服务、您个人信息数据统计、登录和委托记录留痕（证券监管部门要求）、平台优化升级、识别您所在地区。</p>
            <p class="list_item text2">（2）本平台采取包括但不限于以下方式收集您的信息：您自主填写或上传、系统自动识别读取、程序接口或SDK获取、客户操作行为记录。</p>
            <p class="list_item text2">（3）<span style="font-weight: bold;">本平台可能收集的您的信息包括但不限于：客户姓名、证件类型、证件号码、性别、联系地址、联系方式、邮政编码、职业、学历、婚姻情况、银行卡信息、客户证件正反面照片、客户个人视频（开立证券账户或更新身份证时录制的视频）、电子邮箱、ip地址、mac地址、cpu识别号、操作系统版本号，imei码、imsi码、您的点击行为、位置信息等。以上您的信息为您办理特定业务以及使用特定功能时进行收集，如您未办理该特定业务或未使用特定功能，则本平台不会收集或仅部分收集。</span></p>
            <p class="list_item text2">（4）<span style="font-weight: bold;">我司在以下所列情况使用所收集的您的信息，包括但不限于：客户身份识别、客户服务、依据相关法律法规要求的登录和委托记录留痕、平台优化升级、您个人信息数据统计、配合监管部门或其他国家有权机关检查要求、法律法规规定的其他事项。</span></p>
            <p class="list_item text2">（5）我司充分尊重您个人信息的保护，将采取各种预防措施来保护所收集的您的信息，保障信息免遭丢失、盗用和误用，以及被擅自取阅、披露、更改或销毁。提请您注意并确认，互联网环境并非百分之百安全，尽管我司已采取相关安全措施，但在互联网上不存在“绝对完善的安全措施”，我司将尽力确保您的信息的安全性。</p>
            <p class="list_item text2 bot">（6）当我司对信息的收集和使用规则有所变更时，我司有权在必要时修改本协议条款，修改后的协议将在本平台界面中实时更新公示，以便您能够及时了解。若您选择同意并继续使用本平台及其服务的，即表示您接受修改后的协议，也将遵循变更后的协议使用平台服务。</p>
        <h5>4、法律责任与免责</h5>
        <p class="list_item">4.1、使用本平台必须遵守国家有关法律和政策，维护国家利益，保护国家安全，对于您违法或违反本协议的使用而引起的一切责任由您承担，与我司无关。由此导致我司损失的，我司有权立即停止提供服务并保留相关记录，以配合司法机关调查和追究法律责任，并有权要求您赔偿。</p>
        <p class="list_item">4.2、由于本平台及平台中所有数据和信息的传输都涉及到互联网服务因素，可能会受到各个环节不稳定因素的影响，存在因不可抗力、计算机病毒、黑客攻击、系统不稳定、您所在位置、证交所数据服务中断、您关机以及其他任何网络、技术、通信线路等原因造成的服务中断或不能满足您要求的风险，您须明白并自行承担以上风险，在适用法律允许的最大范围内，我司在任何情况下不就因使用或不能使用本平台及所发生的特殊的、意外的、直接或间接的损失承担赔偿责任。</p>
        <p class="list_item bot">4.3、因第三方技术故障（如手机运营商部门的通讯线路故障、系统不稳定性）等不可抗事件影响到平台服务的正常运行的，我司将在第一时间与相关单位配合及时处理进行修复，但在系统恢复正常之前您因此而遭受的经济损失，我司不承担责任。</p>
        <h5>5、其他条款</h5>
        <p class="list_item">5.1、本协议所规定的任何条款的部分或全部无效者，不影响其它条款的效力。</p>
        <p class="list_item bot">5.2、本协议的成立、生效、履行和解释，均适用于中华人民共和国法律。双方在履行本协议过程中，如发生争议，应协商解决。协商不成的，任何一方均可向我司住所地有管辖权的人民法院（深圳市福田区人民法院）提起诉讼。</p>
    </div>
  </div>
</template>
<style>
body{
  height:100%;
  padding: 0;
  margin:0;
}

</style>
<script>
import "../../service/td-h5-hybird-sdk";
export default {
  components: {
  },
  directives: {},
  data() {
    return {
    };
  },
// {data:[]}
  computed: {

  },
  activated() {
  },
  mounted() {
  },
  updated() {},
  beforeDestroy() {},
  methods: {
  }
};
</script>
<style lang="less" >
@import "./style/private.less";
</style>
<style>
</style>